import {
  OpensearchSearchRequestOpenSearchDataTypeEnum,
  PaginationResultsCostCenterTableDto,
  OpensearchSearchResponseListObject,
  FinancialAccountTopUpRequest,
  CostCenterExpensesResponse,
  CreateCostCenterRequestDto,
  EditCostCenterRequestDto,
  AvailablePaymentCardDto,
  CostCenterDisplayDto,
  FinancialAccountDto,
  InvoiceResponse,
  CostCenterDto,
  SearchRequest,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';
import qs from 'qs';

export async function getCostCenters(): Promise<CostCenterDto[]> {
  return httpClient.get('cost-centers').json();
}

export async function getCostCentersPaginated(
  params: SearchRequest,
): Promise<PaginationResultsCostCenterTableDto> {
  const searchParams = qs.stringify(params, { allowDots: true });
  return httpClient.get(`cost-centers/search`, { searchParams }).json();
}

export async function createCostCenter(data: CreateCostCenterRequestDto): Promise<void> {
  return httpClient.post('cost-centers', { json: data }).json();
}

export async function getCostCenter(costCenterId: string): Promise<CostCenterDisplayDto> {
  return httpClient.get(`cost-centers/${costCenterId}`).json();
}

export async function getCostCenterExpensesSummary(
  costCenterId: string,
): Promise<CostCenterExpensesResponse> {
  return httpClient.get(`cost-centers/${costCenterId}/expense-summary`).json();
}

export async function getCostCenterTopUpsHistory(
  openSearchDataType: OpensearchSearchRequestOpenSearchDataTypeEnum,
  costCenterId: string,
  filters?: { dateFrom?: string; dateTo?: string },
): Promise<OpensearchSearchResponseListObject> {
  // This is here because it is static for dashboard widget. In Future it will be changed to opensearch request
  const searchParams = qs.stringify(
    {
      openSearchDataType,
      pageSize: 10,
      dateFrom: filters?.dateFrom,
      dateTo: filters?.dateTo,
    },
    { allowDots: true },
  );
  return httpClient.get(`cost-centers/${costCenterId}/top-ups`, { searchParams }).json();

  // return getOpensearchTableData({
  //   openSearchDataType: OpensearchSearchRequestOpenSearchDataTypeEnum.ACCOUNT_TOP_UPS,
  //   costCenterId,
  //   filters,
  // });
}

/** TODO: Change type from backend */
export async function getCostCenterAccountData(
  costCenterId: string,
): Promise<{ currency: string; amount: number }> {
  return httpClient.get(`cost-centers/${costCenterId}/account-summary`).json();
}

export async function editCostCenter({
  id,
  data,
}: {
  data: EditCostCenterRequestDto;
  id: string;
}): Promise<void> {
  return httpClient.put(`cost-centers/${id}`, { json: data }).json();
}

export async function getCostCentersAccountNumbers(): Promise<FinancialAccountDto[]> {
  return httpClient.get('financial-accounts').json();
}

export async function getCostCenterLinkedCards(
  accountId: string,
): Promise<AvailablePaymentCardDto[]> {
  return httpClient.get(`financial-accounts/${accountId}/cards`).json();
}

export async function makeTopUp({
  accountId,
  data,
}: {
  data: FinancialAccountTopUpRequest;
  accountId: string;
}): Promise<{ redirectUri: string }> {
  return httpClient
    .post<{ redirectUri: string }>(`financial-accounts/${accountId}/top-up`, { json: data })
    .json();
}

export async function editCostCenterLinkedCards(
  accountId: string,
  data: {
    paymentCards: string[];
  },
): Promise<void> {
  return httpClient.post(`financial-accounts/${accountId}/details`, { json: data }).json();
}

// TODO: add Types from BE
export const getInvoicesList = async (
  costCenterId: string,
  pageSize: number,
): Promise<InvoiceResponse[]> => {
  const searchParams = qs.stringify({ pageSize }, { allowDots: true });
  return httpClient.get(`cost-centers/${costCenterId}/invoices`, { searchParams }).json();
};
